import axios from "axios";
import { decryptData } from "utils/secretKey";

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${localStorage.getItem("token")}` || "",
  },
  withCredentials: true,
});

http.interceptors.response.use(
  function (response: any) {
    // return response;
    // if (response?.data?.data && typeof response.data.data === "string") {
    //   try {
    //     const decrypted = decryptData(response.data.data);
    //     response.data = JSON.parse(decrypted); // replace with real object
    //   } catch (err) {
    //     console.error("Failed to decrypt or parse response:", err);
    //     // optionally: return Promise.reject(err);
    //   }
    // }
    return response;
  },
  function (err) {
    if (err.message === "Network Error") {
      alert("Please Check your internet connection");
    }
    if (err.response.data.statusCode === 401) {
      if (
        err.response.config.url !== "/users/signin" &&
        err.response.config.url !== "/users/signup"
      ) {
        localStorage.removeItem("clientId");
        localStorage.removeItem("isLogIn");
        alert("Session Expired, Please Login Again");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
